"use strict";

exports.__esModule = true;
exports.default = collectNonEnumProps;
var _setup = require("./_setup.js");
var _isFunction = _interopRequireDefault(require("./isFunction.js"));
var _has = _interopRequireDefault(require("./_has.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Internal helper to create a simple lookup structure.
// `collectNonEnumProps` used to depend on `_.contains`, but this led to
// circular imports. `emulatedSet` is a one-off solution that only works for
// arrays of strings.
function emulatedSet(keys) {
  var hash = {};
  for (var l = keys.length, i = 0; i < l; ++i) hash[keys[i]] = true;
  return {
    contains: function contains(key) {
      return hash[key];
    },
    push: function push(key) {
      hash[key] = true;
      return keys.push(key);
    }
  };
}

// Internal helper. Checks `keys` for the presence of keys in IE < 9 that won't
// be iterated by `for key in ...` and thus missed. Extends `keys` in place if
// needed.
function collectNonEnumProps(obj, keys) {
  keys = emulatedSet(keys);
  var nonEnumIdx = _setup.nonEnumerableProps.length;
  var constructor = obj.constructor;
  var proto = (0, _isFunction.default)(constructor) && constructor.prototype || _setup.ObjProto;

  // Constructor is a special case.
  var prop = 'constructor';
  if ((0, _has.default)(obj, prop) && !keys.contains(prop)) keys.push(prop);
  while (nonEnumIdx--) {
    prop = _setup.nonEnumerableProps[nonEnumIdx];
    if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) {
      keys.push(prop);
    }
  }
}